export default {
  path: '/appApiManage',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'appApiManage',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
